/* eslint-disable indent */

const initialState = {
    canHaveMultipleLots: true,
};

const FeaturesReducer = (state = initialState, action) => state;

export default FeaturesReducer;
